import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

import { fetchInteraction, sendDisagreement } from '../../../ducks/email'

import FormPaddingWrapper from '../../../components/UI/FormPaddingWrapper'
import Preloader from '../../../components/UI/Preloader'
import Disagreement from '../../../components/Interaction/Disagreement'
import Message from '../../Email/Message'

class DisagreementPage extends Component {
  componentDidMount() {
    const { interactionId, token } = this.props.match.params

    if (!interactionId || !token) {
      this.props.location.replace('/')
    }

    this.props.fetchInteraction({
      interactionId,
      token
    })
  }

  render() {
    const { loading } = this.props.email

    return (
      <div>
        {loading ? (
          <Preloader />
        ) : (
          <FormPaddingWrapper>
            <div className="d-flex flex-column align-items-center">
              {this.renderBody()}
            </div>
          </FormPaddingWrapper>
        )}
      </div>
    )
  }

  renderBody = () => {
    const { sendDisagreement, t } = this.props
    const {
      interaction,
      isModalOpen,
      error,
      success,
      loadingRequest
    } = this.props.email

    if (error.code) {
      return <Message>{t(`errors:${error.code}`)}</Message>
    }

    return (
      <React.Fragment>
        {success && (
          <Message>
            <h1>
              {interaction.state === 'Closed'
                ? t('tickets:ticketHasBeenReopened')
                : t('tickets:ticketHasBeenEscalated')}
            </h1>
          </Message>
        )}
        <Disagreement
          toggle={() => {}}
          isOpen={isModalOpen}
          sendDisagreement={sendDisagreement}
          isTicketClosed={interaction.state === 'Closed'}
          allowToClose={false}
          loading={loadingRequest}
        />
      </React.Fragment>
    )
  }
}

export default compose(
  withRouter,
  withNamespaces(),
  connect(
    ({ email }) => ({ email }),
    { fetchInteraction, sendDisagreement }
  )
)(DisagreementPage)
